import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
const { Option, OptGroup } = Select;

const SubMenuDropdown = ({
  mode,
  defaultValue,
  data,
  disabled,
  placeholder,
  onChange,
  className,
  maxTagCount,
}) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (selectedValue) => {
    setValue(selectedValue);
    if (onChange) {
      onChange(selectedValue);
    }
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <Select
      placeholder={placeholder}
      disabled={disabled}
      className={
        className
          ? className
          : '!h-5.4 flex justify-start items-center rounded-xl border-grey lg:w-31 xl:w-40'
      }
      mode={mode === 'multiple' ? 'multiple' : ''}
      value={value}
      onChange={handleChange}
      maxTagCount={maxTagCount}
    >
      {data?.map((category, index) => (
        <OptGroup key={`category-${index}`} label={`Category: ${category.name}`}>
          {category?.subServiceCategories?.length
            ? category?.subServiceCategories.map((item, i) => (
                <Option
                  key={`option-${index}-${i}-${item._id}`}
                  value={item._id}
                >
                  {item?.name}
                </Option>
              ))
            : ''}
        </OptGroup>
      ))}
    </Select>
  );
};

export default SubMenuDropdown;
